<template>
  <div id="serviceMobile">
    <Slider ref="slider" class="slider">
      <div class="slide" :style="{'background-image': 'url(' + image + ')'}" v-for="image of images"></div>
    </Slider>
    <div class="dots" v-if="$refs.slider && $refs.slider.getPageCount() > 1">
      <div class="dot" v-for="n in $refs.slider.getPageCount()" :class="{active: $refs.slider.getPage === n - 1}"></div>
    </div>
    <div class="contact" v-if="service && (service.phoneNumber || service.email || schedules.getForService(service.id) || service.link) && user.token">
      <ExternalLink class="button" target="_system" v-if="service.phoneNumber" :url="'tel:' + service.phoneNumber">
        <div class="icon">
          <img src="@/assets/img/icons/phone.png">
        </div>
        <div class="name">{{ $t("service.call") }}</div>
      </ExternalLink>
      <ExternalLink class="button" v-if="service && service.email" :url="'mailto:' + service.email" target="_system">
        <div class="icon">
          <img src="@/assets/img/icons/mail.png">
        </div>
        <div class="name">{{ $t("service.contact") }}</div>
      </ExternalLink>
      <ExternalLink class="button" v-if="service && service.link" :url="service.link" target="_blank">
        <div class="icon">
          <img src="@/assets/img/icons/website.png">
        </div>
        <div class="name">{{ $t("service.website") }}</div>
      </ExternalLink>
      <router-link :to="'/new-booking?service=' + service.id" class="button" v-if="schedules.getForService(service.id)">
        <div class="icon">
          <img src="@/assets/img/icons/booking.png">
        </div>
        <div class="name">{{$t('service.book')}}</div>
      </router-link>
    </div>

    <div class="section" v-if="service && $to(service.description) && $to(service.description).length > 0">
      <div class="leftIcon">
        <svgicon src="svg/info.svg" :width=20 :height=20></svgicon>
      </div>
      <div class="content">{{ $to(service.description) }}</div>
    </div>

    <div class="parent-section">
      <div class="section" v-if="service && service.link">
        <div class="leftIcon">
          <svgicon src="svg/site.svg" :width=20 :height=20></svgicon>
        </div>
        <div class="content">
          <ExternalLink :url="service.link" target="_blank">{{ service.link }}</ExternalLink>
        </div>
      </div>
      <div class="section" v-if="service && service.email">
        <div class="leftIcon">
          <svgicon src="svg/mail.svg" :width=20 :height=20></svgicon>
        </div>
        <div class="content">
          <ExternalLink :url="'mailto:' + service.email" target="_system">{{ service.email }}</ExternalLink>
        </div>
      </div>
      <div class="section" v-if="service && service.phoneNumber">
        <div class="leftIcon">
          <svgicon src="svg/phone.svg" :width=20 :height=20></svgicon>
        </div>
        <div class="content">
          <ExternalLink :url="'tel:' + service.phoneNumber" target="_system">{{ service.phoneNumber }}</ExternalLink>
        </div>
      </div>
    </div>
    <div class="section" v-if="service && service.externalLinks && service.externalLinks.length > 0">
      <div class="leftIcon">
        <svgicon src="svg/internet.svg" :width=20 :height=20></svgicon>
      </div>
      <ul class="content" v-if="service && service.externalLinks && service.externalLinks.length > 1">
        <li v-for="(link, linkIndex) of service.externalLinks" :key="'link' + linkIndex" v-if="link.url">
          <ExternalLink target="_blank" :url="link.url">{{$to(link.name) || link.url}}</ExternalLink>
        </li>
      </ul>
      <div class="content" v-if="service && service.externalLinks && service.externalLinks.length === 1">
        <ExternalLink target="_blank" :url="service.externalLinks[0].url">{{$to(service.externalLinks[0].name) || service.externalLinks[0].url}}</ExternalLink>
      </div>
    </div>

    <div class="section" v-if="service && service.documents && service.documents.length > 0">
      <div class="leftIcon">
        <svgicon src="svg/folder.svg" :width=20 :height=20></svgicon>
      </div>
      <div class="content">
        <div class="subtitle">{{ $t("service.documents") }}</div>
        <br>
        <div class="documents">
          <div class="document" v-for="(document, documentIndex) of service.documents" :key="'document-' + documentIndex">
            <div class="icon">
              <svgicon src="svg/paperclip.svg" :height="20" :width="20"></svgicon>
            </div>
            <div class="name">{{document.name}}</div>
            <ExternalLink class="btn btn-neutral" :url="(CONFIG.urlFiles + document.url)" target="_blank">
              <svgicon src="svg/download.svg" :height="16" :width="16" ></svgicon>
            </ExternalLink>
          </div>
        </div>
      </div>
    </div>

    <div class="section" v-if="hasOpeningHours">
      <div class="leftIcon">
        <svgicon src="svg/hours.svg" :width=20 :height=20></svgicon>
      </div>
      <div class="content">
        <div class="subtitle">{{ $t("service.open_hours") }}</div>
        <div class="line" @click="showHours = !showHours">
          <div class="grow"><b>{{ $t("service.today") }}</b></div>
          <div v-if="todayHours && todayHours.hours.length > 0 && isOpenNow">
            <div v-for="h of todayHours.hours">{{ h.from }} {{ $t("to") }} {{ h.to }}</div>
          </div>
          <div v-if="!todayHours || !isOpenNow">
            {{ $t("service.close_now") }}
          </div>
          <div class="arrow">
            <img v-if="!showHours" src="@/assets/img/icons/down.png">
            <img v-if="showHours" src="@/assets/img/icons/up.png">
          </div>
        </div>
        <div class="line hour" v-for="day of openHours" v-if="showHours">
          <div class="grow">{{ $t("weekDays." + day.day) }}</div>
          <div v-if="day.hours.length > 0">
            <div v-for="h of day.hours">{{ h.from }} {{ $t("to") }} {{ h.to }}</div>
          </div>
          <div v-else>{{ $t("service.close") }}</div>
          <div class="arrow"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import Slider from "../Slider.vue";
  import ExternalLink from "../ExternalLink.vue";

  export default {

    name: "ServiceMobile",

    components: { Slider, ExternalLink },

    data() {
      return {
        showHours: true,
        CONFIG
      }
    },

    props: {
      user: Object,
      service: Object,
      schedules: Object,
      images: Array,
      days: Array,
      openHours: Array,
      hasOpeningHours: Boolean
    },

    mounted() {
      setTimeout(()=>this.$forceUpdate(),0);
      this.showHours = this.hasOpeningHours;
    },

    computed: {
      todayHours() {
        if (!this.service) {
          return {
            open: false,
            hours: []
          };
        }
        let todayNameInEnglish = this.days[moment().format('e')];
        return this.service.hours[todayNameInEnglish];
      },
      isOpenNow() {
        let format = 'hh:mm:ss'
        let time = moment();

        for(let timeSlot of this.todayHours.hours) {
          if(time.isBetween( moment(timeSlot.from, format),  moment(timeSlot.to, format))) {
            return true;
          }
        }
        return false;
      }
    },
    methods: {

    }

  }
</script>

<style lang="scss" scoped>
  #serviceMobile {
    background-color: #f2f3f4;
    height: 100%;
    flex-grow:1;
    overflow-y: auto;
  }

  #service .section .line.hour {
    min-height: 30px;
  }

  .slider {
    min-height: 200px;
    max-height: 200px;
    background-color: white;
    .slide {
      background-size: cover;
      background-position: center;
    }
  }

  .contact {
    display: flex;
    margin: 0 20px;
    padding: 20px 0;
    border-bottom: 1px solid #d9dcde;
    .button {
      flex-grow: 1;
      flex-basis: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #405159;
      .icon {
        width: 40px;
        height: 40px;
        background-color: #405159;
        border-radius: 50%;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .dots {
    position: relative;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: white;
      border: 2px solid white;
      &.active {
        background-color: black;
      }
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }

  .fade {
    position: relative;
    overflow: hidden;
    //height: 1.2em; /* exactly three lines */
  }
  .fade:after {
    content: "";
    text-align: right;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20%;
    height: 100%;
    background: linear-gradient(to right, rgba(242, 243, 244, 0), rgba(242, 243, 244, 1) 80%);
  }

  .documents {
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;

    .document {
      width: 100%;
      margin: 0 0 10px 0;
      background-color: white;
    }
    .btn {
      flex-grow: initial;
    }
  }
</style>
